import { useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';

const useMobile = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('lg'));

  return isMobile;
};

export default useMobile;
